import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import './EventDetail.css';

const RavanDahan = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <PageBanner title="Dushehra Ravan Dahan" />

            <div className="event-detail-container">
                <div className="event-detail-grid">
                    {/* Left Column - Event Info */}
                    <div className="event-info-column">
                        <div className="event-header">
                            <span className="event-category">Festival Celebration</span>
                            <h1 className="event-title">Dushehra Ravan Dahan</h1>
                            <p className="event-subtitle">Celebrate the Victory of Good Over Evil</p>
                        </div>

                        {/* Quick Info Cards */}
                        <div className="event-quick-info">
                            <div className="info-card">
                                <i className="fa fa-calendar"></i>
                                <div>
                                    <span className="info-label">Date</span>
                                    <span className="info-value">Tuesday, October 20, 2026</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-clock"></i>
                                <div>
                                    <span className="info-label">Time</span>
                                    <span className="info-value">7:00 PM - 9:00 PM</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-map-marker-alt"></i>
                                <div>
                                    <span className="info-label">Venue</span>
                                    <span className="info-value">Yugal Kunj, Duluth, GA</span>
                                </div>
                            </div>
                            <div className="info-card highlight">
                                <i className="fa fa-users"></i>
                                <div>
                                    <span className="info-label">Welcome</span>
                                    <span className="info-value">Everyone Is Welcome</span>
                                </div>
                            </div>
                        </div>

                        {/* Event Description */}
                        <div className="event-section">
                            <h3 className="section-title">About the Event</h3>
                            <p className="event-description">
                                Celebrate the victory of good over evil with the Ravan Dahan at Yugal Kunj 
                                in the divine presence of Sushri Gopeshwari Devi Ji. An evening of devotion, 
                                celebration and community for the whole family.
                            </p>
                        </div>

                        {/* Event Highlights */}
                        <div className="event-section">
                            <h3 className="section-title">Event Highlights</h3>
                            <ul className="highlights-list">
                                <li><i className="fa fa-check-circle"></i>Ravan Dahan Ceremony</li>
                                <li><i className="fa fa-check-circle"></i>Divine Presence of Sushri Gopeshwari Devi Ji</li>
                                <li><i className="fa fa-check-circle"></i>Devotional Programs</li>
                                <li><i className="fa fa-check-circle"></i>Community Celebration</li>
                            </ul>
                        </div>

                        {/* Action Buttons */}
                        <div className="event-actions">
                            <a
                                href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-primary"
                            >
                                <i className="fa fa-map-marker-alt"></i> Get Directions
                            </a>
                            <a
                                href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/e9c23204_ravan-dahan.jpeg"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-secondary"
                            >
                                <i className="fa fa-download"></i> Download Flyer
                            </a>
                        </div>
                    </div>

                    {/* Right Column - Flyer */}
                    <div className="event-flyer-column">
                        <div className="flyer-wrapper">
                            <img
                                src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/e9c23204_ravan-dahan.jpeg"
                                alt="Dushehra Ravan Dahan"
                                className="event-flyer-image"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default RavanDahan;
